// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1qG-9","colMin":"styles_colMin__3Se_S","colCheckbox":"styles_colCheckbox__rHhjk"};